import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SaveConsolidationRulesMutationVariables = Types.Exact<{
  input: Types.SaveConsolidationRulesInput;
}>;


export type SaveConsolidationRulesMutation = { __typename?: 'Mutation', saveConsolidationRules: { __typename?: 'SaveConsolidationRulesPayload', success: boolean, consolidationRules?: { __typename?: 'ConsolidationRules', version: number, name: string, note: string, savedAt: Types.TDateISO, savedBy: string, productionPlanIds: Array<string>, siteLocationIds: Array<string>, demand: { __typename?: 'ConsolidationDemandRules', lastReadyWeek?: number | null, laterDemandProductionPlanId?: string | null, skipProductionCategoryIds: Array<string> }, sites: { __typename?: 'ConsolidationSiteRules', enabled: boolean, onlyToSitesWithRecipe: boolean, customerGroupSites: Array<{ __typename?: 'ConsolidationCustomerGroupSites', customerGroupId: string, siteLocationIds: Array<string> }>, siteLimits: Array<{ __typename?: 'ConsolidationSiteLimit', siteLocationId: string, productionCategoryIds: Array<string>, note?: string | null }>, lastSeason: { __typename?: 'ConsolidationLastSeasonRule', enabled: boolean, productionPlanIds: Array<string>, matchOn: Types.ConsolidationLastSeasonMatch, fallback: Types.ConsolidationLastSeasonFallback, minSharePercent?: number | null } }, minimumRuns: { __typename?: 'ConsolidationMinimumRunRules', enabled: boolean, groupBy: Types.ConsolidationRunGrouping, smallestMinimum: number, smallestMinimumUnit: Types.ConsolidationQuantityUnit, closeEnoughPercent: number, slowWeeks: { __typename?: 'ConsolidationSlowWeekRule', enabled: boolean, belowPercentOfPeak: number, minimumPercent: number }, merge: { __typename?: 'ConsolidationMergeRule', earlierWeeks: number, laterWeeks: number, maxTimesMinimum: number }, stillShort: { __typename?: 'ConsolidationStillShortRule', flag: boolean, removeUnderPercentOfSeason?: number | null, roundUp: boolean }, minimums: Array<{ __typename?: 'ConsolidationMinimumRow', productionCategoryId: string, bySite: Array<{ __typename?: 'ConsolidationSiteMinimum', siteLocationId: string, minimumEaches?: number | null }> }> }, genusMinimum: { __typename?: 'ConsolidationGenusMinimumRules', enabled: boolean, minQuantity: number, maxMoveWeeks?: number | null }, readyWindows: { __typename?: 'ConsolidationReadyWindowRules', enabled: boolean, weeksAre: Types.ConsolidationWindowWeeks, whenMissing: Types.ConsolidationMissingWindow, flagEdgePileUps: boolean, windows: Array<{ __typename?: 'ConsolidationReadyWindow', customerGroupId: string, productionCategoryId: string, genus?: string | null, firstWeek?: number | null, lastWeek?: number | null }> }, smallRuns: { __typename?: 'ConsolidationSmallRunRules', enabled: boolean, underQuantity: number, unit: Types.ConsolidationQuantityUnit, direction: Types.ConsolidationMoveDirection, keepRolling: boolean, maxMoveWeeks?: number | null }, tidyUp: { __typename?: 'ConsolidationTidyUpRules', mergeIdentical: boolean, foldUnderQuantity: number, sameColorFirst: boolean, takeBiggerLotsCustomerGroup: boolean }, extraDemand: { __typename?: 'ConsolidationExtraDemandRules', enabled: boolean, sources: Array<{ __typename?: 'ConsolidationExtraDemandSource', name: string, mode: Types.ConsolidationExtraDemandMode, productionPlanId?: string | null, customerIds: Array<string>, customerGroupIds: Array<string>, offsetCustomerGroupId?: string | null, offsetSiteLocationId?: string | null, detail?: string | null }> }, plannerChanges: { __typename?: 'ConsolidationPlannerChangeRules', keepByDefault: boolean, pinnedNeverMove: boolean } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SaveConsolidationRulesDocument = new TypedDocumentString(`
    mutation SaveConsolidationRules($input: SaveConsolidationRulesInput!) {
  saveConsolidationRules(input: $input) {
    consolidationRules {
      ...ConsolidationRulesFields
    }
    errors {
      code
      message
    }
    success
  }
}
    fragment ConsolidationRulesFields on ConsolidationRules {
  version
  name
  note
  savedAt
  savedBy
  productionPlanIds
  siteLocationIds
  demand {
    lastReadyWeek
    laterDemandProductionPlanId
    skipProductionCategoryIds
  }
  sites {
    enabled
    onlyToSitesWithRecipe
    customerGroupSites {
      customerGroupId
      siteLocationIds
    }
    siteLimits {
      siteLocationId
      productionCategoryIds
      note
    }
    lastSeason {
      enabled
      productionPlanIds
      matchOn
      fallback
      minSharePercent
    }
  }
  minimumRuns {
    enabled
    groupBy
    smallestMinimum
    smallestMinimumUnit
    closeEnoughPercent
    slowWeeks {
      enabled
      belowPercentOfPeak
      minimumPercent
    }
    merge {
      earlierWeeks
      laterWeeks
      maxTimesMinimum
    }
    stillShort {
      flag
      removeUnderPercentOfSeason
      roundUp
    }
    minimums {
      productionCategoryId
      bySite {
        siteLocationId
        minimumEaches
      }
    }
  }
  genusMinimum {
    enabled
    minQuantity
    maxMoveWeeks
  }
  readyWindows {
    enabled
    weeksAre
    whenMissing
    flagEdgePileUps
    windows {
      customerGroupId
      productionCategoryId
      genus
      firstWeek
      lastWeek
    }
  }
  smallRuns {
    enabled
    underQuantity
    unit
    direction
    keepRolling
    maxMoveWeeks
  }
  tidyUp {
    mergeIdentical
    foldUnderQuantity
    sameColorFirst
    takeBiggerLotsCustomerGroup
  }
  extraDemand {
    enabled
    sources {
      name
      mode
      productionPlanId
      customerIds
      customerGroupIds
      offsetCustomerGroupId
      offsetSiteLocationId
      detail
    }
  }
  plannerChanges {
    keepByDefault
    pinnedNeverMove
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SaveConsolidationRules: build.mutation<SaveConsolidationRulesMutation, SaveConsolidationRulesMutationVariables>({
      query: (variables) => ({ document: SaveConsolidationRulesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSaveConsolidationRulesMutation } = injectedRtkApi;
